export default __webpack_public_path__ + "static/media/profile-hacker-alpha.fd5df14a.png";